import React from 'react'
import { Signal } from '../utils/signals'
import { WidgetConfig } from './WidgetConfiguration'

type Props = {
  children: React.ReactNode
  widgetId: string
  configSignal: Signal<WidgetConfig>
}

type State = {error: undefined | Error}

export class WidgetErrorBoundary extends React.Component<Props, State> {
  state: State = {error: undefined}

  static getDerivedStateFromError(error: Error): State {
    return {error}
  }

  componentDidMount() {
    this.props.configSignal.connect(this.configUpdated)
  }

  componentWillUnmount() {
    this.props.configSignal.disconnect(this.configUpdated)
  }

  configUpdated = () => {
    setTimeout(() => this.setState({error: undefined}))
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    console.error('Widget encountered an error', error, errorInfo)
  }

  render(): React.ReactNode {
    if (this.state.error) {

      return (
        <div role="alert" className="p-4 bg-red-100 text-red-800 rounded-md">
          <h2 className="font-bold mb-2">Something went wrong.</h2>
          <pre className="text-sm whitespace-pre-wrap mb-3">
            {this.state.error?.message ?? 'Unknown error'}
          </pre>
        </div>
      )
    }

    return this.props.children
  }
}
